export const sendWhatsapp = () => {
  const phone = '551140204411'

  const whatsappUrl = `https://wa.me/+55${phone}`

  window.open(whatsappUrl, '_blank')
}
